import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient();

export const queryKeys = {
    GET_SETTINGS: ['GET_SETTINGS'],
    GET_LOGS_RELOAD_SETTINGS: ['GET_LOGS_RELOAD_SETTINGS'],
};

export default queryClient;
